import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'isManager'
})
export class IsManagerPipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    return null;
  }

}
